import { Suspense } from 'react';

import { BrowserRouter as Router } from 'react-router-dom';

import SpinnerView from '@@/auto/components/SpinnerView';

import Routes from './Routes';

export default function ToggleRouter() {
  return (
    <Router>
      <Suspense
        fallback={<SpinnerView data-testid="suspense_fallback_spinnerView" />}
      >
        <Routes />
      </Suspense>
    </Router>
  );
}
